import styled from 'styled-components';

export const CircleMenuBlock = styled.div`
 position: fixed;
 bottom: 30px;
 right: 50px;
 height: 60px;
 width: 60px;
 z-index: 999;
`;

export const CircleButton = styled.button<{ active?: boolean }>`
 height: 60px;
 width: 60px;
 border: none;
 outline: none;
 background: url(${(props) => (!props.active ? '/operator.png' : '/cmc.svg')});
 background-repeat: no-repeat;
 background-position: center center;
 background-color: #0089cb;
 cursor: pointer;
 border-radius: 100%;
 z-index: 2;
 position: relative;
 animation: ${(props) => (props.active ? 'default' : 'pulse 2s ease infinite')};

 @keyframes default {
  0% {
   scale: 1;
  }
  100% {
   scale: 1;
  }
 }

 @keyframes pulse {
  0% {
   scale: 1.15;
  }
  50% {
   scale: 1;
  }
  100% {
   scale: 1.15;
  }
 }
`;

export const SocialList = styled.ul`
 background-color: transparent;
 list-style: none;
 position: relative;
 background-size: 50%;
 margin-bottom: 0;
`;

export const SocialListItem = styled.li<{ opened?: boolean }>`
 height: ${(props) => (props.opened ? '40px' : null)};
 width: ${(props) => (props.opened ? '40px' : null)};

 a {
  height: ${(props) => (props.opened ? '100%' : null)};
  width: ${(props) => (props.opened ? '100%' : null)};
  display: block;
  border-radius: 50%;
  position: relative;
  background-repeat: no-repeat;
  background-position: center center;
 }
`;

export const Viber = styled.a<{ opened?: boolean }>`
 top: ${(props) => (props.opened ? '-115px' : null)};
 left: ${(props) => (props.opened ? '-32px' : null)};
 background: url(${(props) => (props.opened ? '/viber.png' : '')});
`;

export const Telegram = styled.a<{ opened?: boolean }>`
 top: ${(props) => (props.opened ? '-135px' : null)};
 left: ${(props) => (props.opened ? '-80px' : null)};
 background: url(${(props) => (props.opened ? '/telegram.png' : '')});
`;

export const Max = styled.a<{ opened?: boolean }>`
 top: ${(props) => (props.opened ? '-135px' : null)};
 left: ${(props) => (props.opened ? '-80px' : null)};
 background: url(${(props) => (props.opened ? '/max.svg' : '')});
`;

export const Chat = styled.a<{ opened?: boolean }>`
 top: ${(props) => (props.opened ? '-125px' : null)};
 left: ${(props) => (props.opened ? '-95px' : null)};
 background: url(${(props) => (props.opened ? '/ch.png' : '')});
`;
